/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { InjectionToken } from '@angular/core';
/**
 * @record
 */
export function Config() { }
if (false) {
    /** @type {?} */
    Config.prototype.envUrl;
}
/**
 * @ignore
 * @type {?}
 */
export var CONFIG = new InjectionToken('config');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52LmNvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiJuZzovL0BpbnNpZ2h0L3NlcmVuaXR5LWVudi8iLCJzb3VyY2VzIjpbImxpYi9lbnYuY29uZmlnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sZUFBZSxDQUFDOzs7O0FBRS9DLDRCQUVDOzs7SUFERyx3QkFBZTs7Ozs7O0FBTW5CLE1BQU0sS0FBTyxNQUFNLEdBQUcsSUFBSSxjQUFjLENBQVMsUUFBUSxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgSW5qZWN0aW9uVG9rZW4gfSBmcm9tICdAYW5ndWxhci9jb3JlJztcclxuXHJcbmV4cG9ydCBpbnRlcmZhY2UgQ29uZmlnIHtcclxuICAgIGVudlVybDogc3RyaW5nO1xyXG59XHJcblxyXG4vKipcclxuICogQGlnbm9yZVxyXG4gKi9cclxuZXhwb3J0IGNvbnN0IENPTkZJRyA9IG5ldyBJbmplY3Rpb25Ub2tlbjxDb25maWc+KCdjb25maWcnKTtcclxuIl19